import React from 'react';
import { mergeClassNames } from '../../_utils/mergeClassNames';
import './layout-page-header.scss';

export interface LayoutPageHeaderProps {
  children: React.ReactNode;
  className?: string;
}

export function LayoutPageHeader({ children, className }: LayoutPageHeaderProps) {
  return (
    <header className={mergeClassNames('layout-page-header', className)}>
      <div className="layout-page-header__inner">{children}</div>
    </header>
  );
}
